"use strict";import{MenuGroup as e}from"./src/MenuGroup.js";import{defineElement as r}from"@spectrum-web-components/base/src/define-element.js";r("sp-menu-group",e);
//# sourceMappingURL=sp-menu-group.js.map
